<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="FM-Epigraph-non-verse-fmepi">Writing a book … compels you to want to sum up your life … I’m not going to give in to that urge. Let someone else sum up my life when it’s over.</p>
<p class="FM-Epigraph-Source-fmeps"><span class="ePub-I">—L</span><span class="ePub-SC-I">ARRY</span><span class="ePub-I"> H</span><span class="ePub-SC-I">AGMAN</span><span class="ePub-I">, </span><span class="ePub-SC-I">IN</span><span class="ePub-I"> </span><span class="ePub-SC-I">THE</span><span class="ePub-I"> </span><span class="ePub-SC-I">POSTSCRIPT</span><span class="ePub-I"> </span><span class="ePub-SC-I">TO</span><span class="ePub-I"> </span><span class="ePub-SC-I">HIS</span><span class="ePub-I"> </span><span class="ePub-SC-I">AUTOBIOGRAPHY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?12c6aa80